<template>
    <section class="checkoutMonitoringSection">
        <h2 class="checkoutTitle">How often will you pay for monitoring?</h2>
        <MonitoringPlanCard :type="selectedPlan.type"
                              :selected="selectedPlan.selected"
                              :level="selectedPlan.level"
                              :price="selectedPlan.price"
                              :description="selectedPlan.description"
                              v-if="selectedPlan" />
        <div class="checkoutPaymentOptions">
            <!-- PAYMENT OPTION -->
            <div class="checkoutPaymentOption"
                 :class="{'selected': monitoringPlanFrequency === 'Monthly'}"
                 @click="selectMonitoringPlanFrequency('Monthly')">
                <div class="checkoutPaymentOption-title">
                    <div class="checkoutPaymentOption-selector"></div>
                    Monthly
                </div>
                <div class="checkoutPaymentOption-description">
                    Auto bill at the end of the month. Preferred method
                </div>
            </div>
            <!-- END PAYMENT OPTION -->
            <!-- PAYMENT OPTION -->
            <div class="checkoutPaymentOption"
                 :class="{'selected': monitoringPlanFrequency === 'Quarterly'}"
                 @click="selectMonitoringPlanFrequency('Quarterly')">
                <div class="checkoutPaymentOption-title">
                    <div class="checkoutPaymentOption-selector"></div>
                    Quarterly
                </div>
                <div class="checkoutPaymentOption-description">
                    At the end of every 4 months.
                </div>
            </div>
            <!-- END PAYMENT OPTION -->
        </div>
    </section>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import MonitoringPlanCard from '../components/MonitoringPlanCard.vue'
export default {
    components: {
        MonitoringPlanCard
    },
    computed: {
        ...mapState(['system']),
        ...mapGetters(['selectedPlan']),
        monitoringPlanFrequency() {
            return this.system.monitoringPlanFrequency
        }
    },
    methods: {
        ...mapActions(['selectMonitoringPlanFrequency'])
    }
}
</script>

<style lang="css"></style>
